export const isDevelopmentRoute = () => {
  return window.location.hostname.indexOf('insighttimer.com') === -1;
};
